/**
 * Simple function to decode a base64 string
 */
function base64UrlDecode(input) {
  // Replace non-url compatible chars with base64 standard chars
  input = input
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  // Pad out with standard base64 required padding characters
  const pad = input.length % 4;
  if (pad) {
    if (pad === 1) {
      throw new Error('InvalidLengthError: Input base64url string is the wrong length to determine padding');
    }
    input += new Array(5-pad).join('=');
  }

  return decodeURIComponent(escape(window.atob(input)));
}

/**
 * Decodes a JWT token containing the m parameter data
 * @param token The JWT token to decode
 * @returns The decoded data or null if decoding fails
 */
export const decodeMParam = (token) => {
  if (!token) return null;
  
  try {
    console.log('Attempting to decode token:', token);
    
    // Split the token into parts
    const parts = token.split('.');
    console.log('Token parts:', parts);
    
    if (parts.length !== 3) {
      throw new Error('Invalid token format');
    }
    
    // Decode the payload (second part)
    const payload = base64UrlDecode(parts[1]);
    console.log('Decoded payload:', payload);
    
    // Parse the JSON
    const decoded = JSON.parse(payload);
    console.log('Parsed decoded data:', decoded);
    
    return decoded;
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
};